import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
  code: "el",
  messages: {
    alert: {
      close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF"
    },
    authForm: {
      hidePassword: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD",
      showPassword: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD",
      submit: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1"
    },
    banner: {
      close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF"
    },
    calendar: {
      nextMonth: "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF\u03C2 \u03BC\u03AE\u03BD\u03B1\u03C2",
      nextYear: "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF \u03AD\u03C4\u03BF\u03C2",
      prevMonth: "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF\u03C2 \u03BC\u03AE\u03BD\u03B1\u03C2",
      prevYear: "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF \u03AD\u03C4\u03BF\u03C2"
    },
    carousel: {
      dots: "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B4\u03B9\u03B1\u03C6\u03AC\u03BD\u03B5\u03B9\u03B1 \u03B3\u03B9\u03B1 \u03B5\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7",
      goto: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7 \u03B4\u03B9\u03B1\u03C6\u03AC\u03BD\u03B5\u03B9\u03B1 {slide}",
      next: "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF",
      prev: "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF"
    },
    chatPrompt: {
      placeholder: "\u0395\u03B4\u03CE \u03B3\u03C1\u03AC\u03C8\u03C4\u03B5 \u03C4\u03BF \u03BC\u03AE\u03BD\u03C5\u03BC\u03AC \u03C3\u03B1\u03C2..."
    },
    chatPromptSubmit: {
      label: "\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE"
    },
    colorMode: {
      dark: "\u03A3\u03BA\u03BF\u03C4\u03B5\u03B9\u03BD\u03CC",
      light: "\u03A6\u03C9\u03C4\u03B5\u03B9\u03BD\u03CC",
      switchToDark: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03B5 \u03C3\u03BA\u03BF\u03C4\u03B5\u03B9\u03BD\u03AE \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1",
      switchToLight: "\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C3\u03B5 \u03C6\u03C9\u03C4\u03B5\u03B9\u03BD\u03AE \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1",
      system: "\u03A3\u03CD\u03C3\u03C4\u03B7\u03BC\u03B1"
    },
    commandPalette: {
      back: "\u03A0\u03AF\u03C3\u03C9",
      close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF",
      noData: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1",
      noMatch: "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1",
      placeholder: "\u03A0\u03BB\u03B7\u03BA\u03C4\u03C1\u03BF\u03BB\u03BF\u03B3\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B5\u03BD\u03C4\u03BF\u03BB\u03AE \u03AE \u03B1\u03BD\u03B1\u03B6\u03B7\u03C4\u03AE\u03C3\u03C4\u03B5..."
    },
    contentSearch: {
      links: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03B9",
      theme: "\u0398\u03AD\u03BC\u03B1"
    },
    contentSearchButton: {
      label: "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7..."
    },
    contentToc: {
      title: "\u03A3\u03B5 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1"
    },
    dashboardSearch: {
      theme: "\u0398\u03AD\u03BC\u03B1"
    },
    dashboardSearchButton: {
      label: "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u03A3\u03CD\u03BC\u03C0\u03C4\u03C5\u03BE\u03B7 \u03C0\u03BB\u03B5\u03C5\u03C1\u03B9\u03BA\u03AE\u03C2 \u03BC\u03C0\u03AC\u03C1\u03B1\u03C2",
      expand: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03C0\u03BB\u03B5\u03C5\u03C1\u03B9\u03BA\u03AE\u03C2 \u03BC\u03C0\u03AC\u03C1\u03B1\u03C2"
    },
    dashboardSidebarToggle: {
      close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF \u03C0\u03BB\u03B5\u03C5\u03C1\u03B9\u03BA\u03AE\u03C2 \u03BC\u03C0\u03AC\u03C1\u03B1\u03C2",
      open: "\u0386\u03BD\u03BF\u03B9\u03B3\u03BC\u03B1 \u03C0\u03BB\u03B5\u03C5\u03C1\u03B9\u03BA\u03AE\u03C2 \u03BC\u03C0\u03AC\u03C1\u03B1\u03C2"
    },
    error: {
      clear: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B7\u03BD \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE"
    },
    fileUpload: {
      removeFile: "\u0391\u03C6\u03B1\u03AF\u03C1\u03B5\u03C3\u03B7 {filename}"
    },
    header: {
      close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF \u03BC\u03B5\u03BD\u03BF\u03CD",
      open: "\u0386\u03BD\u03BF\u03B9\u03B3\u03BC\u03B1 \u03BC\u03B5\u03BD\u03BF\u03CD"
    },
    inputMenu: {
      create: '\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 "{label}"',
      noData: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1",
      noMatch: "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1"
    },
    inputNumber: {
      decrement: "\u039C\u03B5\u03AF\u03C9\u03C3\u03B7",
      increment: "\u0391\u03CD\u03BE\u03B7\u03C3\u03B7"
    },
    modal: {
      close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF"
    },
    pricingTable: {
      caption: "\u03A3\u03CD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7 \u03C0\u03C1\u03BF\u03B3\u03C1\u03B1\u03BC\u03BC\u03AC\u03C4\u03C9\u03BD \u03C4\u03B9\u03BC\u03BF\u03BB\u03CC\u03B3\u03B7\u03C3\u03B7\u03C2"
    },
    prose: {
      codeCollapse: {
        closeText: "\u03A3\u03CD\u03BC\u03C0\u03C4\u03C5\u03BE\u03B7",
        name: "\u03BA\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2",
        openText: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7"
      },
      collapsible: {
        closeText: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7",
        name: "\u03B9\u03B4\u03B9\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2",
        openText: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7"
      },
      pre: {
        copy: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1 \u03C3\u03C4\u03BF \u03C0\u03C1\u03CC\u03C7\u03B5\u03B9\u03C1\u03BF"
      }
    },
    selectMenu: {
      create: '\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 "{label}"',
      noData: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1",
      noMatch: "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1",
      search: "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7..."
    },
    slideover: {
      close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF"
    },
    table: {
      noData: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1"
    },
    toast: {
      close: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF"
    }
  }
});
